import { DndContext, DragOverlay } from "@dnd-kit/core";
import DroppableColumn from "../../../components/KanbanBoard/DroppableColumn";
import { useKanbanBoard } from "../../../Hooks/Features/KanbanBoard/useKanbanBoard";
import "./kanbanBoard.css";
import { SkeletonContainer } from "../../../components/Loader/Loader";
import { Dropdown } from "primereact/dropdown";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { MultiSelect } from "primereact/multiselect";
import PanelHeaderTemplate from "../../../components/CommonCompo/PanelHeadeTemplate/PanelHeaderTemplate";

function KanbanBoard() {
    const { sensors, activeId, activeTask, handleDragStart, handleDragEnd, selectMode, setSelectMode, selectedCardIds, setSelectedCardIds, moveSelectedCardsToColumn, option, filterValue, setFilterValue, loader, normalizedColumns, expandedSections, handleToggleSection, getKanbanDetails, getEpicList, customCollisionDetection } = useKanbanBoard();

    return (
        <div className="kanban-board">
            <div>
                <h5>Kanbarn Board</h5>
            </div>
            <div className="row">
                <div className="col-md-3 col-6">
                    <div className="d-flex gap-3">
                        <input type="text" placeholder="Search" value={filterValue?.search} onChange={(e) => setFilterValue((prev) => ({ ...prev, search: e.target.value }))} />
                        <div className="d-flex">
                            {
                                option?.userList?.map((value) => {
                                    const isSelected = filterValue?.user?.includes(value?.user_code);
                                    return (
                                        <div
                                            key={value?.user_code}
                                            className="c-pointer rounded-circle user-filter"
                                            style={{ border: isSelected ? "2px solid rgb(15, 15, 155)" : "", zIndex: isSelected ? 5 : 1, backgroundColor: isSelected && "white" }}
                                            title={value?.user_name}
                                            onClick={() => {
                                                setFilterValue((prev) => {
                                                    const currentUsers = prev.user || [];
                                                    const newUsers = isSelected
                                                        ? currentUsers.filter((code) => code !== value.user_code)
                                                        : [...currentUsers, value.user_code];

                                                    return { ...prev, user: newUsers };
                                                });
                                            }}
                                        >
                                            <img
                                                className="rounded-circle"
                                                src={value?.image_url}
                                                alt={value?.user_name}
                                                width={25}
                                                height={25}
                                            />
                                        </div>
                                    );
                                })
                            }
                        </div>
                    </div>
                </div>
                <div className="col-md-2 col-6">
                    <MultiSelect
                        value={filterValue?.projects}
                        onChange={(e) => setFilterValue((prev) => ({ ...prev, projects: e.value }))}
                        placeholder="Select a project"
                        options={option?.projects}
                        optionLabel="project_name"
                        className="w30"
                        onHide={() => { getKanbanDetails(); getEpicList() }}
                        filter
                        filterInputAutoFocus
                        panelHeaderTemplate={(options) => PanelHeaderTemplate(options, 'projects', filterValue?.projects, () => setFilterValue((prevState) => ({
                            ...prevState,
                            projects: [],
                        })))}
                    />
                </div>
                <div className="col-md-2 col-6">
                    <MultiSelect
                        value={filterValue?.epic}
                        onChange={(e) => setFilterValue((prev) => ({ ...prev, epic: e.value }))}
                        placeholder="Select a epic"
                        options={option?.epicList}
                        optionLabel="issue_summary"
                        className="w30"
                        onHide={() => { getKanbanDetails() }}
                        filter
                        filterInputAutoFocus
                        panelHeaderTemplate={(options) => PanelHeaderTemplate(options, 'epic', filterValue?.epic, () => setFilterValue((prevState) => ({
                            ...prevState,
                            epic: [],
                        })))}
                    />
                </div>
                <div className="col-md-2 col-6">
                    <Dropdown
                        value={filterValue?.groups}
                        onChange={(e) => setFilterValue((prev) => ({ ...prev, groups: e.value }))}
                        placeholder="Select a group"
                        options={option?.agileGroups}
                        optionLabel="group_name"
                        className="p-1"
                        filter
                        filterInputAutoFocus />
                </div>
                <div className=" col-md-2 col-6 text-right">
                    <button
                        onClick={() => {
                            setSelectMode(!selectMode);
                            setSelectedCardIds([]);
                        }}
                    >
                        {selectMode ? "Cancel Select" : "Select Cards"}
                    </button>
                </div>
            </div>
            <div className="py-2" style={{ height: "90%", overflowY: "auto" }}>
                {
                    loader ? <div className="d-flex gap-2 justify-content-between w100 " style={{ height: "100%" }}>
                        {Array.from({ length: 5 }, (_, index) => (
                            <SkeletonContainer />
                        ))}
                    </div> :
                        Object.entries(normalizedColumns).map(([userKey, userCol]) => {
                            if (!userCol) return null;
                            const workItemCount = Object.values(userCol.groups || {}).reduce(
                                (sum, group) => sum + (group.items?.length || 0),
                                0
                            );
                            const isExpanded = expandedSections[userKey] || userCol?.id === "all";
                            return (
                                <div className="my-4" key={userKey}>
                                    {userCol?.id !== "all" && (
                                        <div
                                            className="d-flex align-items-center gap-2 c-pointer"
                                            onClick={() => handleToggleSection(userKey)}
                                        >
                                            <FontAwesomeIcon icon={isExpanded ? "fa-solid fa-angle-down" : "fa-solid fa-angle-right"} />
                                            <img className="rounded-circle" src={userCol?.image_url} alt={userKey} width={25} height={25} />
                                            {userCol?.feature_issue_key}  <p className="mb-0">{userKey}</p>
                                            <span>({workItemCount} work items)</span>
                                        </div>
                                    )}
                                    {isExpanded && (
                                        <div className="d-flex justify-content-between gap-2">
                                            <DndContext
                                                sensors={sensors}
                                                collisionDetection={customCollisionDetection}
                                                onDragStart={handleDragStart}
                                                onDragEnd={handleDragEnd}
                                            >
                                                {Object.entries(userCol.groups).map(([groupKey, group]) => (
                                                    <DroppableColumn
                                                        key={groupKey}
                                                        colKey={groupKey}
                                                        column={group}
                                                        selectMode={selectMode}
                                                        selectedCardIds={selectedCardIds}
                                                        setSelectedCardIds={setSelectedCardIds}
                                                        onColumnClick={moveSelectedCardsToColumn}
                                                        activeId={activeId}
                                                    />
                                                ))}
                                                <DragOverlay>
                                                    {activeTask && <div className="overlay">{activeTask.content}</div>}
                                                </DragOverlay>
                                            </DndContext>
                                        </div>
                                    )}
                                </div>
                            );
                        })

                }
            </div>
        </div>
    );
}

export default KanbanBoard;
